import React, {useEffect, useState} from "react";
import apiJson from "../../helper/axios";
import {useNavigate} from "react-router-dom";

export const CatalogSidebar = () => {
    return (
        <>
            <section className="bg-gray-100 p-4">
                <div className="max-w-sm mx-auto bg-white rounded-lg shadow-md">
                    {/* Filter Header */}
                    <div className="border-b p-4">
                        <h2 className="text-lg font-semibold text-gray-700">Filter</h2>
                    </div>
                    {/* Filter Options */}
                    <div className="px-4 py-4 md:py-0 space-y-6 md:space-y-2">
                        {/* Harga Filter */}
                        <div>
                            <div className="mb-2">
                                <label htmlFor="harga" className="block text-sm font-medium text-gray-600">
                                    Harga
                                </label>
                            </div>
                            <div>
                                <select
                                    id="harga"
                                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="all">Semua Harga</option>
                                    <option value="low">Murah ke Mahal</option>
                                    <option value="high">Mahal ke Murah</option>
                                </select>
                            </div>
                        </div>
                        {/* Category Filter */}
                        <div>
                            <div className="mb-2">
                                <label htmlFor="category" className="block text-sm font-medium text-gray-600">
                                    Category
                                </label>
                            </div>
                            <div>
                                <select
                                    id="category"
                                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="all">Semua Kategori</option>
                                    <option value="electronics">Elektronik</option>
                                    <option value="fashion">Fashion</option>
                                    <option value="home">Peralatan Rumah</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export const CategorySidebar = ({handleCategoryChange , selectedValue}) => {

    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const getDataCategories = async () => {
        try {
            const response = await apiJson.get("/categories/xray");
            setCategories(response?.data?.data?.categories || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const navigateCategoryChange = (type) => {
        const categoryUrls = {
            metal_detector: "https://metaldetector.co.id",
            x_ray: "https://xray.co.id",
            vision: "https://vision.co.id",
        };

        if (categoryUrls[type]) {
            navigate(categoryUrls[type]);
        } else {
            console.warn(`Unknown category type: ${type}`);
        }
    };


    useEffect(() => {
        getDataCategories();
    }, []);

    return(
        <>
            <section className="bg-white border border-gray-50">
                <div className="max-w-sm mx-auto bg-white ">
                    <div className="border-b p-4">
                        <h2 className="text-md font-semibold text-gray-700">Kategori</h2>
                    </div>
                    <div className="px-4 py-4 md:py-0 space-y-6 md:space-y-2">
                        <div className={""}>
                            <div className={"w-full"}>
                                <div className={"w-full"}>
                                    {categories?.length === 0 ? (
                                        <ul className={"block"}>
                                            <li className={"my-2"}>
                                                <div className={" my-2 py-5 "}>
                                                    <div className={"flex gap-2 border-md "}>
                                                        <div className={"w-11/12 mx-auto my-auto"}>
                                                            <p className={"text-gray-600 text-sm font-semibold my-auto "}>Kategori tidak ditemukan</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>

                                    ): (
                                        <ul className={"block"}>
                                            {categories?.map((item, index ) => {
                                                return(
                                                    <>
                                                        <li key={index} className={"md:my-0 my-2"}>
                                                            <SelectCardSidebar
                                                                selectedValue={selectedValue}
                                                                value={item?.slug}
                                                                handleOnChange={() => handleCategoryChange(item.slug)}
                                                                name={item?.name} image={item?.image} />
                                                        </li>
                                                    </>
                                                )
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export const CategoryMiniSidebar = ({handleCategoryChange}) => {

    const [categories, setCategories] = useState([]);
    const getDataCategories = async () => {
        try {
            const response = await apiJson.get("/categories");
            setCategories(response?.data?.data?.categories || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        getDataCategories();
    }, []);

    return(
        <>
            <div className={"flex  gap-3"}>
                <div className={"pt-1"}>
                    <p className={"text-gray-600 font-light my-auto"}>Kategori</p>
                </div>
                <ul className={"flex gap-2  py-2 md:pt-2"}>
                    <li className="border-l -mt-1.5 border-gray-300">
                        <select
                            className="px-5 py-0.5 my-auto cursor-pointer"
                            onChange={handleCategoryChange}
                        >
                            <option value="" disabled>
                                Select category
                            </option>
                            {categories?.map((item , index) => {
                                return(
                                    <option
                                        value={item?.slug}
                                        key={index}
                                        className="text-gray-700 my-auto text-sm font-semibold"
                                    >
                                        {item?.name}
                                    </option>
                                )
                            })}

                        </select>
                    </li>
                </ul>
            </div>
        </>
    )
}

export const ModelsMiniSidebar = ({handleModelChange}) => {

    const [models, setModels] = useState([]);
    const getDataModels = async () => {
        try {
            const response = await apiJson.get("/product-models/xray");
            setModels(response?.data?.data?.models?.data || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };


    useEffect(() => {
        getDataModels();
    }, []);


    return(
        <>
            <div className={"flex  gap-3"}>
                <div className={"pt-1"}>
                    <p className={"text-gray-600 font-light my-auto"}>Model</p>
                </div>
                <ul className={"flex gap-2  py-2 md:pt-2"}>
                    <li className="border-l -mt-1.5 border-gray-300">
                        <select
                            className="px-5 py-0.5 my-auto cursor-pointer"
                            onChange={handleModelChange}
                        >
                            <option value="" disabled>
                                Select models
                            </option>
                            {models?.map((item , index) => {
                                return(
                                    <option
                                        value={item?.slug}
                                        key={index}
                                        className="text-gray-700 my-auto text-sm font-semibold"
                                    >
                                        {item?.name}
                                    </option>
                                )
                            })}

                        </select>
                    </li>
                </ul>
            </div>
        </>
    )
}


export const ModelsSidebar = ({handleModelChange , selectedValue}) => {

    const [models, setModels] = useState([]);
    const getDataModels = async () => {
        try {
            const response = await apiJson.get("/product-models/xray"); // Fix endpoint
            setModels(response?.data?.data?.models?.data || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };


    useEffect(() => {
        getDataModels();
    }, []);

    return(
        <>
        <section className="bg-white border border-gray-50">
                <div className="max-w-sm mx-auto bg-white ">
                    <div className="border-b p-4">
                        <h2 className="text-md font-semibold text-gray-700">Models</h2>
                    </div>
                    <div className="px-4 py-4 md:py-1 ">
                        <div className={""}>
                            <div className={"w-full"}>
                                <div className={"w-full"}>
                                    {models?.length === 0 ? (
                                        <ul className={"block"}>
                                            <li className={"my-2"}>
                                                <div className={" my-2 py-5"}>
                                                    <div className={"flex gap-2 border-md "}>
                                                        <div className={"w-11/12 mx-auto my-auto"}>
                                                            <p className={"text-gray-600 text-sm font-semibold my-auto "}>Kategori tidak ditemukan</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>

                                    ): (
                                        <ul className={"block"}>
                                            {models?.map((item, index ) => {
                                               return(
                                                    <li key={index} className={"my-2 md:my-0"}>
                                                        <SelectCardSidebar
                                                            selectedValue={selectedValue}
                                                            value={item?.slug}
                                                            handleOnChange={() => handleModelChange(item.slug)}
                                                            name={item?.name} image={item?.image} />
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export const SelectCardSidebar = ({ name, image, handleOnChange, value, selectedValue }) => {
    return (
        <button onClick={handleOnChange} className="w-full">
            <div className="border-b my-2  py-4 md:py-0 rounded-lg md::my-0  hover:bg-gray-50 md:px-2  border-gray-50 ">
                <div className="flex gap-2">
                    <div className="h-12  ">
                        <input
                            type="radio"
                            value={value}
                            checked={selectedValue === value}
                            onChange={handleOnChange}
                            className="h-4 w-4 my-4"
                        />
                    </div>
                    <div className="w-10/12  text-left mx-auto my-auto">
                        <p className="text-gray-600 text-md">{name || "Unknown Category"}</p>
                    </div>
                </div>
            </div>
        </button>
    );
};


